import gql from 'graphql-tag';

export default gql`
  query searchStakeholders($text: String!) {
    stakeholders(
      where: {
        OR: [
          { firstName_contains: $text }
          { lastName_contains: $text }
          { email_contains: $text }
          { idNumber_contains: $text }
          { postalAddress_contains: $text }
          { residentialAddress_contains: $text }
          { cellNumber_contains: $text }
        ]
      }
    ) {
      id
      firstName
      lastName
      homeNumber
      cellNumber
      email
      idNumber
      residentialAddress
      postalAddress
      role
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/SearchStakeholders.ts